module.exports = __webpack_public_path__ + "images/tips/info-image-01@1x.6c9f249b907bfe50e2b3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-01@1x.png
// module id = qGzW
// module chunks = 24